import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const LineChartUpIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 21 21" fill="none" {...props}>
    <path
      d="M19.5 19.5H2.41667C1.83328 19.5 1.54158 19.5 1.31876 19.3865C1.12276 19.2866 0.963403 19.1272 0.863535 18.9312C0.75 18.7084 0.75 18.4167 0.75 17.8333V0.75M18.4583 5.95833L14.3762 10.3153C14.2215 10.4804 14.1441 10.5629 14.0508 10.6056C13.9684 10.6433 13.8777 10.6588 13.7875 10.6507C13.6853 10.6415 13.5849 10.5893 13.384 10.4851L9.99096 8.72326C9.79014 8.61898 9.68974 8.56685 9.58754 8.55764C9.49733 8.54951 9.40657 8.56505 9.3242 8.60271C9.23088 8.64539 9.15353 8.72795 8.99882 8.89307L4.91667 13.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
